module.exports = __webpack_public_path__ + "img/caret-left-square-fill.13a5ff44.svg";